export const ImageVariant = {
  HeroXs: 'hero_xs',
  HeroS: 'hero_s',
  HeroM: 'hero_m',
  DetailXs: 'detail_xs',
  DetailS: 'detail_s',
  DetailM: 'detail_m',
  SponsorLogoXs: 'sponsor_logo_xs',
  SponsorLogoS: 'sponsor_logo_s',
  ThumbnailXs: 'thumbnail_xs',
  SquareLogoXs: 'square_logo_xs',
  SquareLogoS: 'square_logo_s',
  SquareLogoM: 'square_logo_m',
  Contain: 'contain',
} as const;
export type ImageVariant = (typeof ImageVariant)[keyof typeof ImageVariant];

export const VARIANT_DIMENSIONS: Partial<Record<ImageVariant, { width: number; height: number }>> = {
  [ImageVariant.HeroXs]: { width: 275, height: 175 },
  [ImageVariant.HeroS]: { width: 550, height: 350 },
  [ImageVariant.HeroM]: { width: 1200, height: 764 },
  [ImageVariant.DetailXs]: { width: 400, height: 238 },
  [ImageVariant.DetailS]: { width: 972, height: 578 },
  [ImageVariant.DetailM]: { width: 1500, height: 893 },
  [ImageVariant.SponsorLogoXs]: { width: 300, height: 188 },
  [ImageVariant.SponsorLogoS]: { width: 600, height: 376 },
  [ImageVariant.ThumbnailXs]: { width: 240, height: 135 },
  [ImageVariant.SquareLogoXs]: { width: 50, height: 50 },
  [ImageVariant.SquareLogoS]: { width: 100, height: 100 },
  [ImageVariant.SquareLogoM]: { width: 200, height: 200 },
};

/**
 * The "no variant" choice in the Image CMS component. Not an `ImageVariant`: picking it means
 * "don't ask the assets proxy for a preset size", which is what unlocks the free width/height
 * configuration. Kept as a distinct sentinel so `ImageVariant` stays exactly the set of sizes
 * the proxy can actually serve.
 */
export const IMAGE_VARIANT_NONE = 'none';

export type ImageBlockVariant = ImageVariant | typeof IMAGE_VARIANT_NONE;

/**
 * What the image field writes: a stored path plus its alt text — an asset's `path` when picked
 * from the media library, or the uploaded file's path for a one-time image.
 */
export type ImageBlockSelection = {
  src?: string;
  alt?: string;
};

export type ImageBlockFormData = {
  image?: ImageBlockSelection;
  variant: ImageBlockVariant;
  /** Only meaningful when `variant` is `none`; ignored otherwise. */
  preserveAspectRatio?: boolean;
  /** A CSS length — `320px` or `100%`. `100%` fills the CMS column. */
  width?: string;
  /** A CSS length — `240px` or `100%`. */
  height?: string;
};

export const VARIANT_RESPONSIVE_SRCSET: Partial<Record<ImageVariant, ImageVariant[]>> = {
  [ImageVariant.HeroS]: [ImageVariant.HeroXs, ImageVariant.HeroS, ImageVariant.HeroM],
  [ImageVariant.DetailS]: [ImageVariant.DetailXs, ImageVariant.DetailS, ImageVariant.DetailM],
  [ImageVariant.SponsorLogoXs]: [ImageVariant.SponsorLogoXs, ImageVariant.SponsorLogoS],
};
